// @flow

import Loadable from 'react-loadable';

type Options = {
  loader?: Function,
  render?: Function,
  loading?: any,
  delay?: number,
  timeout?: number,
};

const HOCLoadable = (opts: Options) => {
  return Loadable(
    Object.assign(({ delay: 200, timeout: 10000 }: Options), opts)
  );
};

export default HOCLoadable;



// WEBPACK FOOTER //
// ./src/components/Loadable.js